"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = getRolesForDisplay;

function getRolesForDisplay(roles) {
  return roles.filter(function (_ref) {
    var name = _ref.name;
    return "OWNER" !== name;
  });
}